export const convertEmailToUsername = (email: string) =>
  email.toLowerCase().replaceAll(/[@#]/g, '_');
